import { render, staticRenderFns } from "./colorWarehouse.vue?vue&type=template&id=149c9790"
import script from "./colorWarehouse.vue?vue&type=script&lang=js"
export * from "./colorWarehouse.vue?vue&type=script&lang=js"
import style0 from "./colorWarehouse.vue?vue&type=style&index=0&id=149c9790&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports